import {
  readWorkspaceLocalJson,
  writeWorkspaceLocalJson,
  WS_KEY,
} from "./workspaceStorage";
import { normalizeSearchFilterState } from "./searchFilterState";

function loadAll() {
  try {
    const parsed = readWorkspaceLocalJson(WS_KEY.SAVED_FILTERS, []);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function persist(list) {
  writeWorkspaceLocalJson(WS_KEY.SAVED_FILTERS, list);
}

function newId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `sf-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

/** @returns {Array<{ id, nome, favorito, createdAt, state }>} */
export function getSavedFilters() {
  return loadAll()
    .filter((f) => f && typeof f === "object" && f.id && f.nome)
    .map((f) => ({
      ...f,
      state: normalizeSearchFilterState(f.state || {}),
    }))
    .sort((a, b) => {
      const fa = a.favorito ? 1 : 0;
      const fb = b.favorito ? 1 : 0;
      if (fb !== fa) return fb - fa;
      return String(b.createdAt || "").localeCompare(String(a.createdAt || ""));
    });
}

export function saveFilter({ nome, state, favorito = false }) {
  const trimmed = String(nome || "").trim();
  if (!trimmed) throw new Error("Informe um nome para o filtro");

  const entry = {
    id: newId(),
    nome: trimmed,
    favorito: Boolean(favorito),
    createdAt: new Date().toISOString(),
    state: normalizeSearchFilterState(state),
  };

  const next = [...loadAll(), entry];
  persist(next);
  return entry;
}

export function deleteSavedFilter(id) {
  const next = loadAll().filter((f) => String(f.id) !== String(id));
  persist(next);
}

export function toggleSavedFilterFavorite(id) {
  const next = loadAll().map((f) =>
    String(f.id) === String(id) ? { ...f, favorito: !f.favorito } : f
  );
  persist(next);
}

export function renameSavedFilter(id, nome) {
  const trimmed = String(nome || "").trim();
  if (!trimmed) return;
  const next = loadAll().map((f) =>
    String(f.id) === String(id) ? { ...f, nome: trimmed } : f
  );
  persist(next);
}
